import { Button } from '@/view/components/ui/button'
import { Input } from '@/view/components/ui/input'
import { Spinner } from '@/view/components/ui/spinner'
import { Search } from 'lucide-react'
import React from 'react'
import { useLinksController } from './useLinksController'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import QRCodeModal from './components/QRCodeModal'
import CreateLinkModal from './components/CreateLinkModal'

const Links = () => {
  const {
    data,
    isFetching,
    hasNextPage,
    isFetchingNextPage,
    handleSearchInputChange,
    ref,
    searchValue,
    isModalOpen,
    selectedLink,
    isCreateLinkModalOpen,
    newLinkName,
    selectedTable,
    setIsCreateLinkModalOpen,
    setNewLinkName,
    setSelectedTable,
    handleOpenModal,
    handleCloseModal,
    handleCreateLink,
    isPending,
    // handleLinkClick,
  } = useLinksController()

  return (
    <div className="min-h-[1280px]">
      <h1 className="text-2xl font-semibold"> Links de autocontratação</h1>
      <p className="my-5 font-medium text-black04">
        Compartilhe um link para que seus clientes simulem e solicitem o saque
        sozinhos. Você acompanha tudo por aqui e recebe sua comissão
      </p>

      <div className="w-full border-b-[1px] bg-gray01" />
      <div className="my-5 flex flex-col-reverse items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="w-full">
          <div className="relative flex w-full items-center">
            <Search size={20} className="z-2 absolute left-4 top-3" />
            <Input
              className="w-full rounded-lg pl-10 sm:w-96"
              placeholder="Pesquisar"
              onChange={handleSearchInputChange}
              value={searchValue}
            />
          </div>
        </div>
        <Button
          type="submit"
          className="w-full rounded-lg bg-primary text-base font-bold text-white01 sm:w-auto"
          onClick={() => setIsCreateLinkModalOpen(true)}
        >
          <i className="fa-solid fa-link mr-2" />
          Criar novo link
        </Button>
      </div>
      <div className="space-y-4">
        {data &&
          data.pages.map((page, index) => (
            <React.Fragment key={index}>
              {page.links.map((link) => (
                <div
                  key={link._id}
                  className="flex items-center justify-between border-b border-gray01 pb-4"
                >
                  <div
                    className="flex flex-1 cursor-pointer flex-col items-start"
                    onClick={() => handleOpenModal(link)}
                  >
                    <p className="mb-2 text-base font-semibold text-black01">
                      {link.name}
                    </p>
                    <div className="flex items-center gap-5">
                      <p className="text-sm font-medium text-black04">
                        Acessos:
                        <span className="ml-1 font-semibold text-black01">
                          {link.entry_count.length}
                        </span>
                      </p>
                      <p className="text-sm font-medium text-black04">
                        Valor contratado:
                        <span className="ml-1 font-semibold text-black01">
                          {formatMoneyValue(link.total_transactions)}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <Button
                      variant="ghost"
                      className="bg-white02 p-2 hover:bg-white02"
                      onClick={() => handleOpenModal(link)}
                    >
                      <i className="fa-solid fa-qrcode text-xl text-black03"></i>
                    </Button>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
      </div>
      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>
      <div>
        {isFetching && !isFetchingNextPage ? (
          <div className="flex items-center justify-center">
            <Spinner />
          </div>
        ) : null}
      </div>
      <QRCodeModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        linkName={selectedLink.name}
      />
      <CreateLinkModal
        visible={isCreateLinkModalOpen}
        newLinkName={newLinkName}
        setNewLinkName={setNewLinkName}
        selectedTable={selectedTable}
        setSelectedTable={setSelectedTable}
        onCreateLink={handleCreateLink}
        isLoading={isPending}
        onClose={() => setIsCreateLinkModalOpen(false)}
      />
    </div>
  )
}

export default Links
